import './logo.scss';
import DSLogo from '../../assets/images/dosomething_logo.svg';

export const Logo = () => {
  return <img className="logo" src={DSLogo} alt="DoSomething logo"/>;
}